import "./App.css";
import "./index.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import DocumentList from "./pdf-ocr/DocumentsList";
import PDFOCRViewer from "./pdf-ocr/PDFOCRViewer";
import BasicAuthWrapper from "./BasicAuthWrapper"; // Add this import

function App() {
  return (
    <BasicAuthWrapper testUrl="https://ownli-fd.azurewebsites.net/documents">
      <div className="min-h-screen bg-gray-50">
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/documents" replace />} />
            <Route path="/documents" element={<DocumentList />} />
            <Route path="/documents/:documentId" element={<PDFOCRViewer />} />
            <Route path="*" element={<Navigate to="/documents" replace />} />
          </Routes>
        </Router>
      </div>
    </BasicAuthWrapper>
  );
}

export default App;